import styled from "styled-components";
import ButtonToolbar from "components/bootstrap/ButtonToolbar";
const ModalButtonToolbar = styled(ButtonToolbar)`
  justify-content: flex-end;
`;
export default ModalButtonToolbar;
